<app-top-navigation [openLoginWindow]="isLoginOpen"></app-top-navigation>
<div class="drawer" [class.closed]="isDrawerClosed">
	<div class="handler" (click)="isDrawerClosed  = !isDrawerClosed">
		<fa-icon *ngIf="!isDrawerClosed" [icon]="['fas','chevron-left']"></fa-icon>
		<fa-icon *ngIf="isDrawerClosed" [icon]="['fas','chevron-right']"></fa-icon>
	</div>
	<div class="siteContainer">
		<ul ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false" [(activeId)]="activeTab">
			<li [ngbNavItem]="1">
				<a ngbNavLink (click)="toggleLayer('sites')">{{ 'TRANS_REMOTE.TRANS_ARCHAIOLOGICALS' | translate }}</a>
				<ng-template ngbNavContent>
					<div class="tabContainer" *ngIf="$sites | async as sites else loader">
						<ng-container *ngFor="let site of sites">
							<ng-container *ngTemplateOutlet="siteBox;context:{site:site}"></ng-container>
						</ng-container>
					</div>
				</ng-template>
			</li>
			<li [ngbNavItem]="2">
				<a ngbNavLink (click)="toggleLayer('monuments')">{{ 'TRANS_REMOTE.TRANS_MONUMENTS' | translate }}</a>
				<ng-template ngbNavContent>
					<div class="tabContainer" *ngIf="$monuments | async as monuments else loader">
						<ng-container *ngFor="let monument of monuments">
							<ng-container *ngTemplateOutlet="monumentBox;context:{monument:monument}"></ng-container>
						</ng-container>
					</div>
				</ng-template>
			</li>
		</ul>
		<div [ngbNavOutlet]="nav"></div>
	</div>
</div>
<ng-template #loader>
	<div class="step text-center" style="margin-top: 100px">
		<div class="loader-block">
			<svg id="loader2" viewBox="0 0 100 100">
				<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
			</svg>
		</div>
		<div>LOADING....</div>
	</div>
</ng-template>
<div class="map" id="map"></div>
<div id="popUpWindow-sites" class="popUpWindow">
	<ng-container *ngIf="selectedSite | async as site">
		<ng-container *ngTemplateOutlet="siteBox;context:{site:site}"></ng-container>
	</ng-container>
</div>
<div id="popUpWindow-monuments" class="popUpWindow">
	<ng-container *ngIf="selectedMonument | async as monument">
		<ng-container *ngTemplateOutlet="monumentBox;context:{monument:monument}"></ng-container>
	</ng-container>
</div>
<ng-template #siteBox let-site="site">
	<div class="siteBox">
		<div class="carouselContainer">
			<div class="favorites" (click)="isFavorite(site)">
				<fa-icon [icon]="['far','heart']" *ngIf="!isSiteFavorite(site)"></fa-icon>
				<fa-icon class="text-danger" [icon]="['fas','heart']" *ngIf="isSiteFavorite(site)"></fa-icon>
			</div>
			<div class="proFeature" *ngIf="site.free">{{'TRANS_REMOTE.TRANS_FREE' | translate }}</div>
			<ngb-carousel *ngIf="site.slides" [pauseOnHover]="true" [interval]="10000">
				<ng-template ngbSlide *ngFor="let image of site.slides">
					<a [routerLink]="[this.globalDataService.getRemoteContext()+'/'+this.translateService.currentLang+'/site/'+
									site.seotitle]">
						<div class="img-wrapper">
							<div class="img-background"></div>
							<div class="imgContainer" [style.background-image]="'url('+image+')'"></div>
						</div>
					</a>
				</ng-template>
			</ngb-carousel>
		</div>
		<div class="siteInfo">
			<a [routerLink]="[this.globalDataService.getRemoteContext()+'/'+this.translateService.currentLang+'/site/'+
							site.seotitle]">
				<h4>{{globalDataService.getObjectTranslation(site.siteTranslations, 'name')}}</h4>
			</a>
			<div class="metaInfo">
				<div>{{globalDataService.getObjectTranslation(site.siteTranslations, 'address')}}</div>
				<b>{{ 'TRANS_REMOTE.TRANS_VIRTUAL_TOURS' | translate }}:</b> {{site.panoramaImages.length}}
				<span class="separator">-</span>
				<b>{{ 'TRANS_REMOTE.TRANS_MONUMENT_NUMBERS' | translate }}:</b> {{site.totalMonuments}}
				<span class="separator">-</span>
				<ng-container *ngIf="this.mapMonumentsToSite"><b>{{ 'TRANS_REMOTE.TRANS_MONUMENT_3D' | translate }}:</b> {{this.mapMonumentsToSite[site.id]}}</ng-container>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #monumentBox let-monument="monument">
	<div class="siteBox">
		<div class="carouselContainer">
			<div class="favorites" (click)="isMonument(monument)">
				<fa-icon [icon]="['far','heart']" *ngIf="!isMonumentFavorite(monument)"></fa-icon>
				<fa-icon class="text-danger" [icon]="['fas','heart']" *ngIf="isMonumentFavorite(monument)"></fa-icon>
			</div>
			<div class="proFeature" *ngIf="(isSitePurchased(monument.siteId) | async) === false">{{ 'TRANS_REMOTE.TRANS_ONLY_PRO' | translate }}</div>
			<ng-container *ngIf="(getSiteFromMonument(monument.siteId) | async) as monumentSite">
				<div class="proFeature" *ngIf="monumentSite.free">{{ 'TRANS_REMOTE.TRANS_FREE' | translate }}</div>
			</ng-container>

			<ngb-carousel *ngIf="monument.slides" [pauseOnHover]="true" [interval]="10000"
						  [ngClass]="{'notPurchased': (isSitePurchased(monument.siteId) | async) === false}">
				<ng-template ngbSlide *ngFor="let image of monument.slides">
					<a (click)="openMonument(monument)">
						<div class="img-wrapper">
							<div class="img-background"></div>
							<div class="imgContainer" [style.background-image]="'url('+image+')'"></div>
						</div>
					</a>
				</ng-template>
			</ngb-carousel>
		</div>
		<div class="siteInfo">
			<a (click)="openMonument(monument)">
				<h4>{{globalDataService.getObjectTranslation(monument.monumentTranslations, 'name')}}</h4>
			</a>
			<div class="metaInfo">
				<div *ngIf="getSiteFromMonument(monument.siteId) | async as siteDto" style="font-weight: bold;">
					{{globalDataService.getObjectTranslation(siteDto.siteTranslations, 'address')}}
				</div>
				<div>{{globalDataService.getObjectTranslation(monument.monumentTranslations, 'shortDescription')}}</div>
			</div>
		</div>
	</div>
</ng-template>
<app-site-packets [(isPacketOpen)]="isPacketOpen" *ngIf="isPacketOpen && currentSite" [siteId]="currentSite.id"></app-site-packets>
<div class="monumentInformation" [class.fullWidth]="true" *ngIf="isMonumentOpen">
	<div class="closeInfo" (click)="toggleMonument()">
		<fa-icon [icon]="['fas','window-close']"></fa-icon>
	</div>
	<app-monument-detail [monument]="currentMonument" [smallWindow]="false"></app-monument-detail>
</div>
<div class="loaderContainer" *ngIf="flowLoading">
	<div class="loader-block" style="margin-top: 20%;">
		<svg id="loader2" viewBox="0 0 100 100">
			<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
		</svg>
	</div>
	<div>LOADING....</div>
</div>